import React from 'react';

import { usePublicationContext } from 'components/Publication/PublicationContext';
import { useSalesBattlecardContext } from 'components/SalesBattlecard/SalesBattlecardContext';
import { useCommunityViewContext } from 'components/View/CommunityViewContext';

import MarketPositioningWidgetContent from './MarketPositioningWidgetContent';
import { useWidgetContext } from '../Widget/WidgetContext';

const MarketPositioningWidget = () => {
  const { communityId } = useCommunityViewContext();
  const { publication } = usePublicationContext();
  const { selectedCompetitorId: battlecardCompetitorId } = useSalesBattlecardContext();
  const { type, filters, isModalPreview } = useWidgetContext();

  return (
    <MarketPositioningWidgetContent
      widgetType={type}
      communityId={communityId}
      filters={filters}
      competitorOverride={battlecardCompetitorId}
      publicHash={publication?.hash}
      isModalPreview={isModalPreview}
      xAxis={{
        title: 'Quality Score',
        getValue: (point) => point.quality_score,
      }}
    />
  );
};

export default MarketPositioningWidget;
